import { PALETTE } from '../../common/styles/palette';

export const styles = (theme: any) => {
    return {
        root: {
            paddingLeft: '20px',
        },
        selectedReminder: {
            backgroundColor: PALETTE.Contacts.List.SelectedContact.BackGroundColor,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.SelectedContact.HoveredBackGroundColor
            },
        },
        reminder: {
            display: 'flex',
            flex: 1,
            '&:hover': {
                backgroundColor: PALETTE.Contacts.List.HoveredBackGroundColor
            },
        },
        listSection: {
            backgroundColor: 'inherit',
        },
        listSubheaderContainer: {
            backgroundColor: 'inherit',
            padding: 0,
        },
        listSubheader: {
            backgroundColor: "#ff6600",
            color: "white",
        },
        checkedred: {
            backgroundColor: "#ff0000",
            color: "white",
        },
        checkedorange: {
            backgroundColor: "#ff6600",
            color: "white",
        },
        checkedorangelt: {
            backgroundColor: "#fcdbbb",
            color: "#ff6600",
        },
    }
}